/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/56949300
 */

import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import Accordion from '@components/@core/Accordion';
import Settings from '@components/@core/Settings';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import EditDropdown from '@components/EditDropdown';
import { LibraryToDoQuotaDetailMenu, QuotaDirections } from '~/services/config';
import { getSettings } from '~/services/util';
import moment from 'moment';
import { QUOTA_TYPES, QUOTA_FORECASTING, ACTUALS_NUMBER_TYPES } from '~/services/constants';

const Detail = ({ authors, departments, competencies, categories, data, userRole, onSelect }) => {
    const quota_template = useSelector((state) => state.develop.templates.quotas);
    const quota = find(propEq('id', data.id), quota_template?.data || []);

    // Return early if quota is not found
    if (!quota) {
        return (
            <>
                <Filter back="all quotas" />
                <div className="lib-todo-quota" data-cy="quota-detail">
                    <div className="quota-detail">
                        <p>Goal not found</p>
                    </div>
                </div>
            </>
        );
    }

    const departmentIds = quota.data?.department || [];
    const competencyIds = quota.data?.competency || [];
    const categoryIds = quota.data?.category || [];
    const direction = find(propEq('value', quota.quota_direction), QuotaDirections);
    const settings = [
        { name: 'Author', id: [quota.author_id], options: authors },
        { name: 'Departments', id: departmentIds, options: departments },
        { name: 'Competencies', id: competencyIds, options: competencies },
        { name: 'Categories', id: categoryIds, options: categories },
    ];
    const stats = [
        { name: 'Created', value: moment(quota?.created_at).format('MMM DD, YY') || null },
        { name: 'Created By', value: quota?.created_by || 'Na' },
        { name: 'Last Edited', value: moment(quota?.updated_at).format('MMM DD, YY') || null },
        { name: 'Last edits by', value: quota?.edited_by || 'Na' },
        { name: 'Assigned', value: quota?.assigned || 'Na' },
    ];

    const quotaType = QUOTA_TYPES[quota?.quota_value ?? 1];

    return (
        <>
            <Filter back="all quotas" />
            <div className="lib-todo-quota" data-cy="quota-detail">
                <div className="quota-detail">
                    <div className="d-flex jc-between py-2" data-cy="quota-name">
                        <p className="dsl-b18 bold mb-0">Goal</p>
                        {userRole < 3 && <EditDropdown dataCy="editDropdown" options={LibraryToDoQuotaDetailMenu[userRole]} onChange={onSelect} />}
                    </div>

                    <div className="container">
                        <Row>
                            <Col xs={12} sm={12} className="my-1 object-title">
                                <Input disabled className="input-field" title="Name" value={quota.name} />
                            </Col>
                            <Col xs={12} sm={12} className="my-1 object-textarea">
                                <Input disabled className="input-field" title="Descritpion" as="textarea" rows={2} value={quota.data.description || quota.description} />
                            </Col>
                            <Col xs={12} sm={12} className="my-1">
                                <Input disabled className="input-field" title="Type" value={quotaType} />
                            </Col>

                            <Col xs={12} sm={12} className="my-1">
                                <Input disabled className="input-field" title="Direction of Scale" value={direction?.name || 'N/A'} />
                            </Col>
                            <Col xs={12} sm={12} className="my-1">
                                <Input disabled className="input-field" title="Calculation for forcast" value={getSettings([quota.quota_forecasting], QUOTA_FORECASTING, 'N/A')} />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            <Settings values={settings} stats={stats} />
        </>
    );
};

Detail.propTypes = {
    data: PropTypes.any,
    userRole: PropTypes.number,
    editable: PropTypes.bool,
};

Detail.defaultProps = {
    data: {},
    userRole: 1,
    editable: false,
};

export default memo(Detail);
